<template>
  <div>
    <el-dialog
      :title="formData.id ? '编辑片花' : '新增片花'"
      :visible.sync="value"
      width="1200px"
      append-to-body
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <el-form
        :model="formData"
        :disabled="isDisabled"
        :rules="rules"
        ref="formData"
        label-width="100px"
      >
        <div
          style="background-color: #f6f6f6; padding: 25px; border-radius: 10px"
        >
          <!-- 第一行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <span style="display: inline-block; width: 100px"
                >乐播片花 ID：</span
              >
              {{ formData.id || '--' }}</el-col
            >
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="对应剧片：" prop="mediaName">
                {{ formData.mediaName || '--' }}
                <!-- <el-input v-model="formData.num"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="片花名称：" prop="aword">
                <el-input
                  v-model="formData.aword"
                  placeholder="请输入片花名称"
                  :maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="类型：" prop="type">
                <el-select
                  v-model="formData.type"
                  style="width: 100%"
                  placeholder="请选择类型"
                >
                  <el-option label="其它" :value="0"></el-option>
                  <el-option label="片花/花絮" :value="1"></el-option>
                  <el-option label="预告片" :value="2"></el-option>
                  <el-option label="高能看点" :value="3"></el-option>
                  <el-option label="二次创作" :value="4"></el-option>
                  <el-option label="一般关系" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="对应分集：" prop="episodeName">
                {{ formData.episodeName || '--' }}
              </el-form-item>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="时长：" prop="duration">
                <el-input
                  v-model="formData.duration"
                  placeholder="请输入时长"
                  :min="0"
                  type="number"
                  @input="
                    () => {
                      if (formData.duration !== '') {
                        const pattern = /^[1-9]\d*$/
                        if (!pattern.test(formData.duration)) {
                          formData.duration = ''
                        }
                      }
                    }
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="横图：" prop="horizontalImgLarge">
                <el-upload
                  class="avatar-uploader"
                  style="display: flex; justify-content: center; width: 330px"
                  :action="actionUrl"
                  :show-file-list="false"
                  :on-success="
                    (res) => {
                      handleAvatarSuccess(res, 'horizontalImgLarge')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="formData.horizontalImgLarge"
                    :src="formData.horizontalImgLarge"
                    style="width: 100%"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="竖图：" prop="verticalImgLarge">
                <el-upload
                  class="avatar-uploader"
                  :show-file-list="false"
                  :action="actionUrl"
                  :on-success="
                    (res) => {
                      handleAvatarSuccess(res, 'verticalImgLarge')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="formData.verticalImgLarge"
                    :src="formData.verticalImgLarge"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第五行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="视频样式：" prop="direction">
                <el-radio-group v-model="formData.direction">
                  <el-radio :label="1">横视频</el-radio>
                  <el-radio :label="2">竖视频</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2"> </el-col>
            <el-col :span="11">
              <el-form-item v-loading="loading" label="播放介质：">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <el-button
                    v-if="!isDisabled"
                    type="mini"
                    @click="choiceMedium"
                    >选择介质</el-button
                  >
                  <span v-if="selectedMedium.name">{{
                    (selectedMedium.name + '.' + selectedMedium.fileFormat)
                      | totoLowerCase()
                  }}</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第六行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11"> </el-col>
            <el-col :span="2"> </el-col>
            <el-col :span="11">
              <el-form-item
                v-loading="loading"
                label="播放链接："
                prop="playUrl"
              >
                <el-input
                  v-model="formData.playUrl"
                  placeholder="请输入播放链接"
                  :maxlength="999"
                  v-if="!isDisabled"
                  @blur="analysisDuration"
                ></el-input>
                <div v-else>
                  {{ formData.playUrl }}
                  <span
                    style="color: #2140ef; cursor: pointer; padding: 0 10px"
                    @click="handleShowImage(formData.playUrl, 'video')"
                    >预览</span
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 第七行 -->
        <el-row style="margin: 0 0 0 50px; padding: 25px 25px 0">
          <el-col :span="11">
            <el-form-item label="片花状态：" prop="status">
              <el-radio-group v-model="formData.status">
                <el-radio :label="1">上线</el-radio>
                <el-radio :label="0">下线</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <div v-if="isDisabled" style="text-align: right">
              <span
                style="color: #2140ef; cursor: pointer; padding: 0 10px"
                @click="innerVisible = true"
                >三方分集信息</span
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span v-if="!isDisabled" slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button @click="mediaEpisodeSave" type="primary">确 定</el-button>
      </span>

      <el-dialog
        width="1000px"
        title="三方分集信息"
        v-if="innerVisible"
        :visible.sync="innerVisible"
        :modal-append-to-body="false"
        :before-close="
          (done) => {
            innerVisible = false
            done()
          }
        "
        append-to-body
      >
        <el-row style="margin: 0 0 20px 50px">
          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >三方分集 ID：</span
            >
            {{
              formData.trailerPartnerData
                ? formData.trailerPartnerData.partnerTrailerId || '--'
                : '--'
            }}</el-col
          >

          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >三方分集状态：</span
            >
            {{
              formData.trailerPartnerData
                ? { 0: '关', 1: '开' }[
                    formData.trailerPartnerData.partnerTrailerStatus
                  ] || '--'
                : '--'
            }}</el-col
          >
        </el-row>

        <el-row style="margin: 0 0 20px 50px">
          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >版权商分集 ID：</span
            >
            {{
              formData.trailerPartnerData
                ? formData.trailerPartnerData.copyrightMediaId || '--'
                : '--'
            }}</el-col
          >

          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >版权商分集编号：：</span
            >
            {{
              formData.trailerPartnerData
                ? formData.trailerPartnerData.copyrightMediaCode || '--'
                : '--'
            }}</el-col
          >
        </el-row>
      </el-dialog>
    </el-dialog>
    <Medium ref="medium" @select="mediumSelect"></Medium>
  </div>
</template>

<script>
import {
  analysisDurationApi,
  addMediaTrailerApi,
  editMediaTrailerApi
} from '@/api/mediaManage/mediaContentManage.js'
import { number } from 'echarts'
import Medium from './medium.vue'
export default {
  name: 'WebSassTrailerInfo',
  components: {
    Medium
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sort: {
      type: number,
      default: 0
    },
    row: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    partnerId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value(val) {
      console.log(val)
      console.log('watch-----------', this.row)

      if (this.row.id) {
        this.formData = {
          ...this.row
        }
      } else {
        this.formData = {
          direction: 1
        }
      }
    }
  },
  computed: {
    rules() {
      const rules = {
        playUrl: [
          { required: true, message: '请输入播放链接', trigger: 'blur' }
        ],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        status: [
          { required: true, message: '请选择片花状态', trigger: 'change' }
        ]
      }
      /** 华视网聚不需要必填播放链接 */
      if (this.partnerId === 2) {
        delete rules.playUrl
      }
      return rules
    }
  },
  data() {
    return {
      selectedMedium: {
        name: '',
        playUrl: '',
        fileFormat: '',
        originDuration: ''
      },
      actionUrl:
        process.env.VUE_APP_BASE_URL +
        '/lebo-resource/oss/endpoint/put-file?code=lebotob', // 上传图片地址
      formData: { direction: 1 },
      innerVisible: false,
      loading: false
    }
  },
  created() {
    if (this.row.id) {
      this.formData = {
        ...this.row
      }
    } else {
      this.formData = {
        direction: 1
      }
    }
  },
  methods: {
    // 选择介质回调
    mediumSelect(row) {
      this.selectedMedium = row
      this.formData.playUrl = row.playUrl
      this.formData.duration = row.originDuration
    },
    // 选择介质
    choiceMedium() {
      this.$refs.medium.show()
    },
    // 预览img，video
    handleShowImage(url, type) {
      console.log('handleShowImage', url, type)
      // let _dom = type === 'video' ? type + ' controls' : 'img'
      // this.$alert(`<${_dom} src='` + url + "' style='width:100%'>", '图片/视频展示', {
      //   dangerouslyUseHTMLString: true,
      //   showConfirmButton: false,
      //   customClass: 'showImage',
      // });
      let _dom = 'video controls'
      this.$alert(
        `<${_dom} src='` + `${url}` + "' style='width:100%'>",
        '图片/视频展示',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: 'showImage',
          callback: () => {
            // 在弹窗关闭时执行停止视频播放的操作
            const videoElement = document.querySelector('.showImage video')
            if (videoElement) {
              videoElement.pause()
            }
          }
        }
      )
    },

    // 获取视频时长，单位秒
    analysisDuration() {
      if (!this.formData.playUrl) return
      let params = {
        videoUrl: this.formData.playUrl
      }
      this.loading = true
      analysisDurationApi(params).then((res) => {
        this.loading = false
        this.$set(this.formData, 'duration', res.data.data)
      })
    },

    // 保存
    mediaEpisodeSave() {
      let params = {
        sort: this.sort + 1,
        mediaId: this.$route.query.id,
        ...this.formData
      }
      let api = this.formData.id ? editMediaTrailerApi : addMediaTrailerApi

      this.$refs.formData.validate((valid) => {
        if (valid) {
          api(params).then((res) => {
            console.log('保存---->', res)
            if (res.data.code === 200) {
              this.closeDialog()
              this.$message.success('保存成功!')
            }
          })
        } else {
          return false
        }
      })
    },

    // 上传图片前校验
    beforeAvatarUpload(file) {
      console.log(file)
      // return true
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('只能上传jpg、jpeg或png格式的图片')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      return isJPG && isLt10M
    },
    // 上传图片后响应
    handleAvatarSuccess(res, key) {
      console.log(res)
      this.$set(this.formData, key, res.data.link)
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 关闭弹框
    closeDialog() {
      this.formData = {}
      this.value = false
      this.$emit('input', false)
    },
    handleClose(done) {
      this.closeDialog()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>